module.exports = __webpack_public_path__ + "static/media/bot-alice.88a335fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/bot-alice.png
// module id = 33
// module chunks = 0